import React from "react";
import moment from "moment-timezone";
import SimpleTooltip from "./SimpleTooltip";
import CopyTimeWrapper from "./CopyTimeWrapper";
import { FiClock } from "react-icons/fi";

class DateTimeFormatter extends React.PureComponent {
  constructor(props) {
    super(props);

    this.formatDatetime = this.formatDatetime.bind(this);
  }

  formatDatetime(value) {
    if (!value) {
      return "-";
    }

    const defaultFormat = "YYYY/MM/DD HH:mm:ss Z";

    const mValue = moment(value);
    const mFormat = this.props.format || defaultFormat;
    const mFromNow = mValue.fromNow();

    if (this.props.fromNowOnly) {
      return mFromNow;
    }

    const fromNow = this.props.timeOnly ? "" : `(${mFromNow})`;

    let timezone = null;
    let timeValue = mValue.format(mFormat);
    if (this.props.timezone) {
      timezone = (
        <SimpleTooltip
          tooltipText={`${this.props.timezone}: ${moment
            .utc(value)
            .tz(this.props.timezone)
            .format(mFormat)}`}
          place={this.props.place}
        >
          <FiClock></FiClock>
        </SimpleTooltip>
      );

      timeValue = (
        <CopyTimeWrapper
          localValue={mValue.clone().tz("Asia/Taipei")}
          tzValue={moment.utc(value).tz(this.props.timezone)}
        >
          {mValue.format(mFormat)}
        </CopyTimeWrapper>
      );
    }

    if (this.props.isLineBreak) {
      return (
        <>
          <div className="flex items-center">
            {timezone || ""}
            {timeValue}
          </div>
          <div>{fromNow}</div>
        </>
      );
    }

    return timezone ? (
      <div className="flex items-center">
        {timezone}
        {timeValue} {fromNow}
      </div>
    ) : (
      <div className="flex items-center">
        {timeValue} {fromNow}
      </div>
    );
  }

  render() {
    const { datetime } = this.props;
    const formattedDatetime = this.formatDatetime(datetime);
    return formattedDatetime;
  }
}

export default DateTimeFormatter;
